module.exports = __webpack_public_path__ + "2bb7c4494a54eda5ee2583e44dc00727.png";